/* COPYRIGHT Esri - https://js.arcgis.com/5.1.20/LICENSE.txt */
class s{destroy(){}}export{s as AComputedField};
